import { render, staticRenderFns } from "./RiseupHeader.vue?vue&type=template&id=4184dd7a&scoped=true&"
import script from "./RiseupHeader.vue?vue&type=script&lang=js&"
export * from "./RiseupHeader.vue?vue&type=script&lang=js&"
import style0 from "./RiseupHeader.vue?vue&type=style&index=0&id=4184dd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184dd7a",
  null
  
)

export default component.exports